var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{on:{"input":value => _vm.Change(value)},model:{value:(_vm.localvalue),callback:function ($$v) {_vm.localvalue=$$v},expression:"localvalue"}},[_vm._v(" >")])
}
var staticRenderFns = []

export { render, staticRenderFns }